<template>
  <div class="issue-check">
    <div class="main">
      <subfield>
        <template slot="list">
          <trees :title="$t('crl1')" type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
        </template>
        <template slot="content">
          <enfold-ucd>
            <template slot="up">
              <div class="c-u-left">
                <el-button type="primary" @click="check" size="mini" round>{{ $t('review.review') }}</el-button>
                <el-button type="danger" @click="mulDelete" size="mini" round>{{ $t('review.deleteRecord') }}</el-button>
              </div>
              <div class="c-u-right">
                <div class="select">
                  <el-select v-model="select_data" @change="selectByType" size="mini">
                    <el-option v-for="item in options" :key="item.value" :label="$t(item.label)" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="search">
                  <el-input v-model="search_data" :placeholder="$t('review.enterKey')" size="mini">
                    <i slot="suffix" class="el-icon-search" @click="search"></i>
                  </el-input>
                </div>
              </div>
            </template>
            <template slot="center">
              <el-table :data="materialList" :row-key="getRowKey" ref="eltable"
                @selection-change="handleSelectionChange" v-loading="tableLoading" height="100%">
                <el-table-column type="selection" :reserve-selection="true" :selectable="(row) => {
                  // return row.publish_state == 0;
                  return true;
                }"></el-table-column>
                <el-table-column prop="publish_no" :label="$t('review.singleNo')" width="180">
                  <template slot-scope="scope">
                    <span @click="openDetail(scope.row)" style="cursor: pointer;">{{ scope.row.publish_name ||
                      scope.row.publish_no }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="gn" :label="$t('review.group')">
                </el-table-column>
                <el-table-column prop="create_time" :label="$t('review.createTime')">
                </el-table-column>
                <el-table-column prop="publish_user" :label="$t('review.publisher')">
                </el-table-column>
                <el-table-column :label="$t('review.operate')">
                  <template slot-scope="scope">
                    <template v-if="scope.row.publish_state == 0">
                      <!-- <span @click="openDetail(scope.row)" style="color: var(--theme-color-customized-1);cursor: pointer;">{{$t('review.review')}}</span> -->
                      <el-button type="success" @click="openDetail(scope.row)" size="mini" round>{{ $t('review.Review')
                      }}</el-button>
                    </template>
                    <template v-if="scope.row.publish_state == 1">
                      <span style="color: red;">{{ scope.row.operate_user }}</span>
                      <span style="margin-left: 10px;">{{ `${scope.row.check_time.substring(0, 10)}` }}</span>
                      <el-popover placement="bottom" width="200" trigger="hover" :content="scope.row.check_remark">
                        <span
                          style="color: var(--theme-color-customized-1); margin-left: 10px;cursor: pointer;white-space: nowrap;"
                          slot="reference">{{ $t('review.check') }}</span>
                      </el-popover>
                    </template>
                    <template v-if="scope.row.publish_state == 2">
                      <span style="color: #00c48f;">{{ scope.row.operate_user }}</span>
                      <span style="margin-left: 10px;">{{ `${scope.row.check_time.substring(0, 10)}` }}</span>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <template slot="down">
              <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
            </template>
          </enfold-ucd>
        </template>
      </subfield>
      <form-dialog :title="$t('review.releaseReview')" :dialogVisible="allCheckVisible" @closeDialog="allCheckClose"
        dWidth="550px">
        <div class="all-main">
          <div class="all-input">
            <el-input v-model="all_reject" :placeholder="$t('review.resonForReject')"></el-input>
          </div>
          <div class="all-button">
            <el-button type="success" round @click="allPublish(2)">{{ $t('review.approve') }}</el-button>
            <el-button type="danger" round @click="allPublish(1)">{{ $t('review.rejectReview') }}</el-button>
          </div>
        </div>
      </form-dialog>
      <counters-check :isVisible="mtCheckVisible" :current_detail="current_detail" :deviceList="deviceList"
        :scheduleList="scheduleList" @closeCheck="closeCheck" @updateData="getIssue()"></counters-check>

      <dele-dialog :title="$t('crl2')" :dialogVisible="delDialogVisible" @closeDialog="delCloseDialog">
        <div style="text-align:center;height: 60px;line-height: 60px">{{ $t('crl3') }}</div>
      </dele-dialog>
    </div>
  </div>
</template>

<script>
import {
  mPagination
} from "@/components/basics/mixins";
import subfield from '@/components/basics/Subfield';
import EnfoldUcd from '@/components/basics/EnfoldUCD';
import pagination from '@/components/basics/Pagination';
import trees from '@/components/basics/Trees';
import FormDialog from '@/components/basics/FormDialog';
import CountersCheck from './children/CountersCheck.vue';
import DeleDialog from "@/components/basics/DelDialog"
export default {
  name: "IssueCheck",
  components: {
    subfield,
    trees,
    EnfoldUcd,
    pagination,
    FormDialog,
    CountersCheck,
    DeleDialog
  },
  mixins: [mPagination],
  data() {
    return {
      groupList: [],
      materialList: [],
      deviceList: [],
      playList: [],
      seleted_list: [],
      scheduleList: [],
      device_table_list: [],
      delDialogVisible: false,
      options: [{
        value: '0,1,2',
        label: 'review.all'
      }, {
        value: '0',
        label: 'review.waitReview'
      }, {
        value: '1',
        label: 'review.reject'
      }, {
        value: '2',
        label: 'review.approves'
      }],

      current: 0,

      search_data: '',
      select_data: '0,1,2',
      reject_data: '',
      all_reject: '',
      current_type: 'play',
      current_detail: null,

      mtCheckVisible: false,
      allCheckVisible: false,
      tableLoading: false,
      isList: true
    }
  },
  methods: {
    mulDelete() {
      if (this.seleted_list.length === 0) {
        this.$msg({
          type: 'warning',
          message: this.$t('review.selectTips1')
        })
      } else {
        //console.log(this.seleted_list)
        this.delDialogVisible = true;
      }
    },
    delCloseDialog(isConfirm) {
      if (isConfirm) {
        let ids = [];
        this.seleted_list.forEach(ele => {
          (ele.publish_state !== 0) && ids.push(ele.id);
        });
        this.$refs.eltable.clearSelection();
        if (ids.length === 0) {
          this.$msg({ type: 'warning', message: this.$t('crl4') });
          return;
        }
        this.$http.post("/admin/check/checkCountersDel", { pids: ids.toString() }, (res) => {
          this.$msg({ type: 'success', message: this.$t('crl5') });
          res > 0 && this.getIssue();
        });
      }
      this.delDialogVisible = false;
    },
    changeList() {
      this.isList = true;
    },
    changeMa() {
      this.isList = false;
    },
    check() {
      if (this.seleted_list.length == 0) {
        this.$msg({
          type: 'warning',
          message: this.$t('crl6')
        })
      } else {
        this.allCheckVisible = true;
      }

    },
    allCheckClose() {
      this.allCheckVisible = false;
    },
    closeCheck() {
      this.mtCheckVisible = false;
    },
    mtCheckClose() {
      this.mtCheckVisible = false;
      this.reject_data = '';
    },

    getRowKey(row) {
      return row.id + this.$uuid.v4();
    },
    currentChange(val) {
      this.page = val;
      this.getIssue();
    },
    getAssets(ids) {
      console.log(ids);
      this.groupId = ids.id;
      this.groupIds = ids.ids;
      this.getIssue();
    },
    handleSelectionChange(val) {
      this.seleted_list = val;
      console.log(val);
    },
    async allPublish(type) {
      let publish_ids = [];
      if (type == 1) {
        if (this.all_reject == '') {
          this.$msg({
            type: 'warning',
            message: this.$t('review.resonForReject')
          })
        } else {
          this.seleted_list.forEach((ele) => {
            publish_ids.push(ele.id)
          });
          await this.$http.post("/admin/check/checkPublish", {
            check_result: type,
            remark: this.all_reject,
            publish_ids: publish_ids.toString()
          })
          this.allCheckVisible = false;
          this.getIssue();
        }
      } else {
        this.seleted_list.forEach((ele) => {
          publish_ids.push(ele.id)
        });
        await this.$http.post("/admin/check/checkPublish", {
          check_result: type,
          remark: this.all_reject,
          publish_ids: publish_ids.toString()
        })
        this.$http.post("/admin/Command/getDownloadList", {}, data => {
          this.$store.commit("ISSUE_LIST", data);
        });
        console.log('刷新.....')
        this.getIssue();
        this.$forceUpdate();
        this.allCheckVisible = false;
      }

    },

    async publish() {
      await this.$http.post("/admin/check/checkPublish", {
        check_result: 2,
        remark: this.reject_data,
        publish_ids: this.current_detail.id
      });
      this.$http.post("/admin/Command/getDownloadList", {}, data => {
        this.$store.commit("ISSUE_LIST", data);
      });
      this.getIssue();
      this.mtCheckVisible = false;
    },
    async reject() {
      if (!this.reject_data) {
        this.$msg({
          type: 'warning',
          message: this.$t('review.resonForReject')
        })
      } else {
        await this.$http.post("/admin/check/checkPublish", {
          check_result: 1,
          remark: this.reject_data,
          publish_ids: this.current_detail.id
        })
        this.getIssue();
        console.log('原因', this.reject_data);
        this.mtCheckVisible = false;
      }
    },
    async openDetail(data) {
      this.mtCheckVisible = true;
      this.current_detail = data;
      await this.$http.post("/admin/publish/cuntersDetail", {
        publish_id: data.id,
      }, res => {
        const { cuntersDetail: { counters_info: countersInfo } } = res;
        const { commands_info, devices_info } = JSON.parse(countersInfo);
        this.scheduleList = commands_info[0].data;
        this.deviceList = devices_info;
      })
    },
    search() {
      this.select_data = '0,1,2';
      this.getIssue();
    },
    selectByType(val) {
      this.select_data = val;
      this.getIssue();
    },
    getIssue() {
      this.tableLoading = true;
      this.$refs.eltable.clearSelection();
      //const group_id = this.$cookies.get("group_id");
      this.$http.post("/admin/check/checkCountersPublishList", {
        limit: this.limit,
        group_id: this.groupId,
        page: this.page,
        publish_state: this.select_data,
        key_word: this.search_data
      }, data => {
        this.materialList = data.data ? data.data : [];
        this.current = parseInt(data.total);
        this.materialList.forEach((ele) => {
          ele.publish_user = ele.user_name.substring(0, ele.user_name.indexOf('&'));
          if (ele.check_user != null) {
            ele.operate_user = ele.check_user.substring(0, ele.check_user.indexOf('&'));
          } else {
            ele.operate_user = ''
          }
        })
        this.tableLoading = false;
      })
    },
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });
    this.tableLoading = true;
    //const group_id = this.$cookies.get("group_id");
    this.$http.post("/admin/check/checkCountersPublishList", {
      limit: this.limit,
      group_id: this.groupId,
      page: this.page,
    }, data => {
      this.materialList = data.data ? data.data : [];
      this.current = parseInt(data.total ? data.total : 0);
      this.materialList.forEach((ele) => {
        ele.publish_user = ele.user_name.substring(0, ele.user_name.indexOf('&'));
        if (ele.check_user != null) {
          ele.operate_user = ele.check_user.substring(0, ele.check_user.indexOf('&'));
        } else {
          ele.operate_user = ''
        }
      })
      this.tableLoading = false;
    })
  }
}
</script>

<style scoped lang="scss">
.issue-check {
  width: 100%;
  height: 100%;

  .all-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100px;

    .all-input {
      width: 100%;
      height: 40px;
    }

    .all-button {
      width: 250px;
      // height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .publish {
      width: 100px;
      height: 40px;
      cursor: pointer;
      border-style: solid;
      border-width: 1px;
      border-image-slice: 1;
      border-color: linear-gradient(270deg,
          #86eae7 0%,
          #4cccf0 45%,
          #11adf8 100%);
      border-radius: 20px;
      color: var(--theme-color-customized-1);
      line-height: 40px;
      text-align: center;
    }

    .reject {
      cursor: pointer;
      width: 100px;
      height: 40px;
      border-style: solid;
      border-width: 1px;
      border-color: linear-gradient(270deg,
          #ff907e 0%,
          #ff7878 45%,
          #ff5f72 100%);
      border-image-slice: 1;
      color: #ff4949;
      line-height: 40px;
      border-radius: 20px;
      text-align: center;
    }
  }

  .main {
    width: 100%;
    height: 100%;

    .c-u-left {

      // margin-left: 10px;
      // width: 130px;
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      .icon {
        width: 30px;
        height: 30px;

        img {
          width: 30px;
          height: 30px;
        }
      }
    }

    .c-u-right {
      display: flex;
      align-items: center;
      // width: 450px;
      justify-content: space-between;

      .select {
        margin-right: 28px;
      }

      .select /deep/ .el-input__inner {
        border-radius: 15px;
      }

      .search /deep/ .el-input__inner {
        border-radius: 15px;
      }

      .icons {
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .icon {
        width: 30px;
        height: 30px;
      }
    }

    .thum {
      width: 98%;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      align-content: flex-start;

      .items {
        width: 180px;
        height: 180px;
        margin-top: 20px;
        border: 1px solid black;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .top_img {
          height: 108px;
          background-color: orange;
          position: relative;

          // .button /deep/ .el-button .el-button--default {
          // 	border: 1px solid black;
          // 	border-color: linear-gradient(270deg,
          // 			#86eae7 0%,
          // 			#4cccf0 45%,
          // 			#11adf8 100%);
          // }

          .button {
            width: 160px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            visibility: hidden;

            .reject {
              width: 80px;
            }
          }

          .timg {
            width: 100%;
            height: 108px;
            // object-fit: scale-down;
          }

          .checkbox {
            position: absolute;
            left: 10px;
            top: 10px;
            visibility: hidden;
          }
        }

        .top_img:hover .checkbox {
          visibility: visible;
        }

        .top_img:hover .button {
          visibility: visible;
        }

        .bottom_name {
          height: 72px;
          display: flex;
          flex-direction: column;

          .name {
            box-sizing: border-box;
            padding-top: 3px;
            padding-left: 3px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            background-color: orange;
            width: 100%;
            height: 36px;
          }

          .check {
            box-sizing: border-box;
            padding-top: 3px;
            padding-left: 3px;
            text-overflow: ellipsis;
            width: 100%;
            height: 36px;
          }
        }
      }
    }
  }

  .diamain {
    width: 96%;
    height: 390px;
    margin: 5px auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    .header {
      width: 100%;
      height: 40px;
      border-bottom: 1px solid #d7ecf3;

      .button-groups {
        width: 360px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .button {
          text-align: center;
          width: 99px;
          height: 30px;
          line-height: 30px;
          border-style: solid;
          border-width: 1px;
          cursor: pointer;
          border-image-slice: 1;
          border-radius: 17px;
          color: var(--theme-color-customized-1);
          letter-spacing: 3px;
        }

        .isButtonActive {
          background-image: linear-gradient(270deg,
              #86eae7 0%,
              #4cccf0 45%,
              #11adf8 100%),
            linear-gradient(#cfd5d8, #cfd5d8);
          background-blend-mode: normal, normal;
          color: #ffffff;
        }
      }

      .button-groups>.button:hover {
        background-color: rgba(216, 255, 253, 0.7);
      }
    }

    .diaimg {
      width: 100%;
      height: 290px;
      overflow-y: auto;

      .tab {
        width: 100%;
        height: calc(100% - 40px);
        overflow-y: hidden;

        background-color: pink;
      }

      /deep/ .el-tabs__content {
        flex-grow: 1;
        overflow-y: auto;
      }
    }

    .diainput {
      height: 60px;
      width: 100%;

      display: flex;
      align-items: center;

      .content {
        width: 70%;
      }

      .button {
        width: 30%;
        padding-left: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .publishs {
          width: 80px;
          height: 35px;
          cursor: pointer;
          border-style: solid;
          border-width: 1px;
          border-image-slice: 1;
          border-color: linear-gradient(270deg,
              #86eae7 0%,
              #4cccf0 45%,
              #11adf8 100%);
          border-radius: 20px;
          color: var(--theme-color-customized-1);
          line-height: 35px;
          text-align: center;
        }

        .reject {
          width: 80px;
          height: 35px;
          cursor: pointer;
          border-style: solid;
          border-width: 1px;
          border-image-slice: 1;
          border-color: linear-gradient(270deg,
              #ff907e 0%,
              #ff7878 45%,
              #ff5f72 100%);
          border-radius: 20px;
          color: #ff4949;
          line-height: 35px;
          text-align: center;
        }
      }
    }
  }

  /deep/ .el-input__suffix {
    line-height: 30px;
    color: var(--theme-color-customized-1);
    font-size: 16px;
    right: 10px;
  }

  .search /deep/ .el-button--default {
    background-color: #edfbff;
    border-left-style: none;
    border-left: 0;
  }

  /deep/ .el-table__header-wrapper {
    .cell {
      font-size: 18px;
      color: var(--theme-color-customized-1);
    }

    th:last-child>.cell {
      text-align: center;
    }
  }
}
</style>
